
<template>
  <!--新增产品分类-->
  <addCategory></addCategory>
</template>

<script>
import addCategory from '@/components/package/addCategory.vue';
export default {
  components: {
    addCategory
  },
  name: 'aadCategory',
  data () {
    return {};
  },
  mounted () {
  },
  methods: {
  }
};
</script>
